<template>
  <v-main id="manage" class="pt-11">
    <v-toolbar flat class="back mb-5">
      <v-btn small text color="grey" @click="close">
        <v-icon>mdi-checkbox-marked-outline</v-icon>
        Voltar
      </v-btn>

      <v-scale-transition>
        <v-alert
          v-show="showError"
          elevation="9"
          type="error"
          class="successAlert"
        >
          {{ errorMessage }}
        </v-alert>
      </v-scale-transition>
    </v-toolbar>
    <v-container class="back py-8">
      <v-row class="py-0" v-show="institutionInactive">
        <v-col class="py-0" cols="12">
          <InstitutionInactive />
        </v-col>
      </v-row>
      <v-row class="py-0" v-show="departmentInactive">
        <v-col class="py-0" cols="12">
          <DepartmentInactive />
        </v-col>
      </v-row>
      <v-row class="pa-0 ma-0">
        <v-col cols="12" sm="6" md="6" lg="6">
          <h2>Itens do Checklist</h2>
        </v-col>
        <v-col class="pt-0" cols="12" sm="6" md="6" lg="6">
          <label class="label d-block">Data e hora execução</label>
          <div class="d-flex">
            <v-icon class="mr-1">mdi-calendar</v-icon>
            <date-picker
              ref="datepicker"
              style="width: 100%"
              v-model="checklistDate"
              mode="dateTime"
              is24hr
              :popover="{ visibility: 'click' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :class="
                    checklistDateError ? 'date-input-error' : 'date-input'
                  "
                  :value="inputValue"
                  v-on="inputEvents"
                  v-mask="['##/##/#### ##:##']"
                  @focus="setNowDate"
                  disabled
                />
                <span class="date-span-error" v-if="checklistDateError"
                  >Data da execução é requerida</span
                >
              </template>
            </date-picker>
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-data-table
        :loading="loading"
        loading-text="Carregando..."
        no-data-text="Nenhum item encontrado"
        :headers="headersMobile"
        :items="checklistItems"
        class="mt-3 hidden-md-and-up"
        hide-default-footer
        :header-props="headerProps"
        :mobile-breakpoint="330"
        :single-expand="false"
        show-expand
        :expanded.sync="expanded"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      >
        <template v-slot:item.checklistItem="{ item }">
          {{ item.itemName }}
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-3">
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>Classe:</strong>
                {{ item.itemClassName }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <div class="d-flex justify-space-between">
                <p>
                  <strong>Sim:</strong>
                  <v-icon
                    disabled
                    @click="setItemYes(item)"
                    :color="item.checklistResponse == 0 ? '#BBCF20' : ''"
                  >
                    {{
                      item.checklistResponse == 0
                        ? 'mdi-checkbox-marked-circle-outline'
                        : 'mdi-checkbox-blank-circle-outline'
                    }}
                  </v-icon>
                </p>
                <p>
                  <strong>Não:</strong>
                  <v-icon
                    disabled
                    @click="setItemNo(item)"
                    :color="item.checklistResponse == 1 ? '#B14949' : ''"
                  >
                    {{
                      item.checklistResponse == 1
                        ? 'mdi-checkbox-marked-circle-outline'
                        : 'mdi-checkbox-blank-circle-outline'
                    }}
                  </v-icon>
                </p>
                <p>
                  <strong>N/A:</strong>
                  <v-icon
                    @click="setItemNotApplication(item)"
                    :color="item.checklistResponse == 2 ? '#426483' : ''"
                  >
                    {{
                      item.checklistResponse == 2
                        ? 'mdi-checkbox-marked-circle-outline'
                        : 'mdi-checkbox-blank-circle-outline'
                    }}
                  </v-icon>
                </p>
              </div>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <strong>Observação:</strong>
              <v-textarea
                hide-details="auto"
                disabled
                class="ma-0 pa-0 text-area-input"
                no-resize
                rows="3"
                v-model="item.observation"
                outlined
              ></v-textarea>
            </v-col>
          </td>
        </template>
      </v-data-table>

      <v-data-table
        :loading="loading"
        loading-text="Carregando..."
        no-data-text="Nenhum item encontrado"
        :headers="headers"
        :items="checklistItems"
        class="mt-3 hidden-sm-and-down"
        hide-default-footer
        :header-props="headerProps"
        disable-pagination
      >
        <template v-slot:item.checklistItem="{ item }">
          {{ item.itemName }}
        </template>

        <template v-slot:item.classItem="{ item }">
          {{ item.itemClassName }}
        </template>

        <template v-slot:item.checklistItemYes="{ item }">
          <v-icon :color="item.checklistResponse == 0 ? '#BBCF20' : ''">
            {{
              item.checklistResponse == 0
                ? 'mdi-checkbox-marked-circle-outline'
                : 'mdi-checkbox-blank-circle-outline'
            }}
          </v-icon>
        </template>
        <template v-slot:item.checklistItemNo="{ item }">
          <v-icon :color="item.checklistResponse == 1 ? '#B14949' : ''">
            {{
              item.checklistResponse == 1
                ? 'mdi-checkbox-marked-circle-outline'
                : 'mdi-checkbox-blank-circle-outline'
            }}
          </v-icon>
        </template>

        <template v-slot:item.checklistItemNotApplicaton="{ item }">
          <v-icon :color="item.checklistResponse == 2 ? '#426483' : ''">
            {{
              item.checklistResponse == 2
                ? 'mdi-checkbox-marked-circle-outline'
                : 'mdi-checkbox-blank-circle-outline'
            }}
          </v-icon>
        </template>

        <template v-slot:item.checklistItemObs="{ item }">
          <v-textarea
            hide-details="auto"
            disabled
            class="ml-5 my-2 text-area-input"
            no-resize
            rows="3"
            v-model="item.observation"
            outlined
          ></v-textarea>
        </template>
      </v-data-table>
    </v-container>
    <div class="mt-2 text-center" flat>
      <v-btn
        v-show="currentChecklist.ChecklistId != null"
        v-if="!currentChecklist.isValidatorSigned"
        color="#BBCF20"
        @click="validateChecklist"
        depressed
        class="mr-4 hidden-md-and-up"
        :loading="validateLoading"
        disabled
      >
        Validar Checklist
      </v-btn>
      <v-card-actions>
        <v-btn class="" color="#B14949" @click="close"> Cancelar </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="#426483"
          @click="submit"
          depressed
          class="mr-4"
          :loading="loading"
          disabled
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </div>
  </v-main>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}

.date-input-error {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 2px solid #ff5252 !important;
  padding-top: 0 !important;
}

.v-data-table .v-icon.v-icon {
  font-size: 2.2rem !important;
}
</style>

<script>
import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
import InstitutionInactive from '../../../../Institutions/components/institutionInactive/institutionInactive.vue'
import DepartmentInactive from '../../../../Department/deparmentInactive/departmentInactive.vue'

export default {
  components: {
    InstitutionInactive,
    DepartmentInactive,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionInactive = this.institution.status == 1
    this.institutionId = this.institution.id
    this.currentUser = JSON.parse(localStorage.getItem('user'))

    this.inputDisabled =
      this.institution.userType > 3 && this.institution.userType != 8
    this.currentChecklist = JSON.parse(sessionStorage.getItem('checklist'))
    this.checklistDate = this.currentChecklist.ChecklistDate
    this.getItemsChecklist()
    this.getDepartmentStatus()
  },

  data: () => ({
    errorMessage: '',
    expanded: [],
    error: false,
    showError: false,
    isEditing: false,
    loading: false,
    validateLoading: false,
    institutionInactive: false,
    departmentInactive: false,
    inputDisabled: false,
    checklistDateError: false,
    institution: null,
    institutionId: null,
    checklistDate: null,
    checklistItems: [],
    currentChecklist: {},
    currentUser: {},
    headers: [
      {
        text: 'Item',
        align: 'center',

        value: 'checklistItem',
        sortable: false,
      },
      {
        text: 'Classe',
        align: 'center',

        value: 'classItem',
        width: '200',
        sortable: false,
      },
      {
        text: 'Sim',
        align: 'center',

        value: 'checklistItemYes',
        width: '50',
        sortable: false,
      },
      {
        text: 'Não',

        align: 'center',
        value: 'checklistItemNo',
        width: '50',
        sortable: false,
      },
      {
        text: 'N/A',

        align: 'center',
        value: 'checklistItemNotApplicaton',
        width: '50',
        sortable: false,
      },
      {
        text: 'Observação',

        align: 'center',
        value: 'checklistItemObs',
        width: '300',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Item',
        align: 'center',

        value: 'checklistItem',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$router.push('/big-data')
    },

    showErrorAlert(message) {
      this.errorMessage = message
      this.showError = true

      setTimeout(() => {
        this.showError = false
      }, 3000)
    },

    setNowDate() {
      this.checklistDate = !this.checklistDate ? new Date() : this.checklistDate
    },

    async getItemsChecklist() {
      this.loading = true

      const checklistServiceOrder = {
        ServiceOrderId: this.currentChecklist.ServiceOrderId,
        ChecklistId: this.currentChecklist.ChecklistId,
        ChecklistTemplateId: this.currentChecklist.ChecklistTemplate
          ? this.currentChecklist.ChecklistTemplate.checklistTemplateId
          : null,
      }

      await this.apiService
        .post('checklistServiceOrder/items', checklistServiceOrder)
        .then((response) => {
          this.checklistItems = response.content
          this.currentChecklist.checklistId = this.checklistItems
            .map((checklist) => checklist.checklistId)
            .filter((id) => id != null)
          this.loading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getDepartmentStatus() {
      await this.apiService
        .get(
          `equipment/${this.institutionId}/${this.currentChecklist.EquipmentId}`
        )
        .then((response) => {
          this.departmentInactive = response.content.department.status == 1
        })
    },

    async validateChecklist() {
      this.validateLoading = true
      if (this.currentUser.signatureImage) {
        const checklist = {
          Id: this.currentChecklist.checklist.id,
          isValidatorSigned: true,
          ValidatorUserId: this.currentUser.id,
        }

        await this.apiService
          .post('checklistServiceOrder/validate', checklist)
          .then(() => {
            this.validateLoading = false
            this.close()
          })
      }
    },

    async submit() {
      const answers = this.checklistItems.map(
        (checklist) => checklist.checklistResponse
      )

      if (answers.includes(null)) {
        window.scrollTo(0, 0)
        this.showErrorAlert(
          'Existe um ou mais items sem resposta, favor verificar'
        )
      } else if (!this.checklistDate) {
        this.checklistDateError = true
      } else {
        const checklistModel = {
          ChecklistId: this.currentChecklist.checklistId[0],
          ChecklistServiceOrders: this.checklistItems,
          isExecutingSigned:
            this.institution.userType <= 3 || this.institution.userType == 8
              ? true
              : false,
          ExecutingUserId:
            this.institution.userType <= 3 || this.institution.userType == 8
              ? this.currentUser.id
              : null,
          ChecklistDate: Utils.nowDatetimeFormat(this.checklistDate),
        }

        await this.apiService
          .post('checklistServiceOrder/save', checklistModel)
          .then((response) => {
            const checklist = response.content
            checklist.isExecutingSigned = checklistModel.isExecutingSigned
            checklist.executingUserId = checklistModel.ExecutingUserId
            this.generatePDF(checklist)
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
        this.$router.push('/checklists')
      }
    },

    async generatePDF(checklist) {
      const route = this.$router.resolve({
        path: `/printChecklist/${checklist.id}`,
      })
      window.open(route.href, '_blank')
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    setItemYes(item) {
      if (item.checklistResponse != 0) {
        item.checklistResponse = 0
      } else {
        item.checklistResponse = null
      }
    },
    setItemNo(item) {
      if (item.checklistResponse != 1) {
        item.checklistResponse = 1
      } else {
        item.checklistResponse = null
      }
    },
    setItemNotApplication(item) {
      if (item.checklistResponse != 2) {
        item.checklistResponse = 2
      } else {
        item.checklistResponse = null
      }
    },
  },

  computed: {},

  watch: {
    checklistDate: {
      deep: true,
      handler() {
        this.checklistDateError = false
      },
    },
  },
}
</script>
